import {GeneralAmenitySelectedType} from "@CheckOrder/features/amenities/types/GeneralAmenitySelected.type";
import entries from "@Object/entries";

export const filterOutEmptySelectedAmenities = (selectedAmenities: Record<string, GeneralAmenitySelectedType> | null) => (
    Object.fromEntries(entries(selectedAmenities ?? {}).filter(([_key, amenity]) => {
        if (amenity.type === "count") {
            return !!amenity.value
        }

        return null
    }))
)